import {
  SELLER_CONNECT_CHAT_ROLE,
  SELLER_CONNECT_INTAKE_STATUS,
  SELLER_CONNECT_SCREENING_MODE,
  SellerConnectChatRole,
  SellerConnectIntakeStatus,
  SellerConnectScreeningMode,
  SELLER_CONNECT_IM_STATUS,
  SellerConnectImStatus,
} from 'models/SellerConnectEngine';
import { COLOR_VARIANT, ColorVariants } from 'models/Colors';

export const INTAKE_VIA_LABELS: Record<SellerConnectScreeningMode, string> = {
  [SELLER_CONNECT_SCREENING_MODE.VOICE]: 'sellChannelVoice',
  [SELLER_CONNECT_SCREENING_MODE.CHAT]: 'sellChannelChat',
  [SELLER_CONNECT_SCREENING_MODE.TEXT]: 'sellChannelForm',
};

export const INTAKE_STATUS_LABELS: Record<SellerConnectIntakeStatus, string> = {
  [SELLER_CONNECT_INTAKE_STATUS.COMPLETE]: 'imStatusComplete',
  [SELLER_CONNECT_INTAKE_STATUS.INCOMPLETE]: 'imStatusIncomplete',
  [SELLER_CONNECT_INTAKE_STATUS.NOT_FINISHED]: 'imStatusIntakeNotFinished',
};

export const TRANSCRIPT_ROLE_LABELS: Record<SellerConnectChatRole, string> = {
  [SELLER_CONNECT_CHAT_ROLE.AGENT]: 'sellerDrawerTranscriptAgent',
  [SELLER_CONNECT_CHAT_ROLE.USER]: 'sellerDrawerTranscriptSeller',
};

export const INTAKE_VIA_COLORS: Record<
  SellerConnectScreeningMode,
  ColorVariants
> = {
  [SELLER_CONNECT_SCREENING_MODE.VOICE]: COLOR_VARIANT.BLUE,
  [SELLER_CONNECT_SCREENING_MODE.CHAT]: COLOR_VARIANT.YELLOW,
  [SELLER_CONNECT_SCREENING_MODE.TEXT]: COLOR_VARIANT.SILVER,
};

export const INTAKE_STATUS_COLORS: Record<
  SellerConnectIntakeStatus,
  ColorVariants
> = {
  [SELLER_CONNECT_INTAKE_STATUS.COMPLETE]: COLOR_VARIANT.GREEN,
  [SELLER_CONNECT_INTAKE_STATUS.INCOMPLETE]: COLOR_VARIANT.ORANGE,
  [SELLER_CONNECT_INTAKE_STATUS.NOT_FINISHED]: COLOR_VARIANT.LIGHT_GREY,
};

export const IM_STATUSES_WITH_PDF: SellerConnectImStatus[] = [
  SELLER_CONNECT_IM_STATUS.READY,
  SELLER_CONNECT_IM_STATUS.SENT,
];
